<template>
	<fragment>
		<c-hero-split invert-mobile image-fill class="illustration-section-01" />
		<!-- <c-clients top-divider bottom-divider /> -->
		<!-- <c-features-split bottom-divider image-fill /> -->
		<c-testimonial class="illustration-section-05" />
		<c-features-tiles />
		<c-pricing pricing-switcher has-bg-color class="illustration-section-07" />
		<!-- <c-testimonial class="illustration-section-05" />
        <c-cta top-divider bottom-divider split class="reveal-from-top" /> -->
	</fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutDefault.vue";
// import sections
import CHeroSplit from "@/components/sections/HeroSplit.vue";
// import CClients from '@/components/sections/Clients.vue'
// import CFeaturesSplit from "@/components/sections/FeaturesSplit.vue";
import CFeaturesTiles from "@/components/sections/FeaturesTiles.vue";
import CPricing from "@/components/sections/Pricing.vue";
import CTestimonial from "@/components/sections/Testimonial.vue";
// import CCta from '@/components/sections/Cta.vue'

export default {
	name: "Home",
	components: {
		CHeroSplit,
		// CClients,
		// CFeaturesSplit,
		CFeaturesTiles,
		CPricing,
		CTestimonial,
		// CCta
	},
	created() {
		this.$emit("update:layout", CLayout);
	},
};
</script>
